import './styles/simonsLayout.css';
import LoadLinkData from "./LoadLinkData";

function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}

export default function NavigateLinks() {

    let filename = "/data/linkdata" + getRandomInt(1, 9) + ".json";

    return (<div id="navBeta" className="sidebox">
            <LoadLinkData formedName={filename}/>
        </div>
    );
}
